IntlMessageFormat.__addLocaleData({"locale":"mn","pluralRuleFunction":function (n,ord){if(ord)return"other";return n==1?"one":"other"}});
IntlMessageFormat.__addLocaleData({"locale":"mn-Cyrl","parentLocale":"mn"});
IntlMessageFormat.__addLocaleData({"locale":"mn-Cyrl-MN","parentLocale":"mn-Cyrl"});
IntlMessageFormat.__addLocaleData({"locale":"mn-Mong","pluralRuleFunction":function (n,ord){if(ord)return"other";return"other"}});
